import Loading from "components/Loading";
import Dashboard from "components/Template/Dashboard";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import ArrowLeft from "icons/arrow-circle-left-green.svg";
import { listGroupById } from "services/group";
import TextInputAuth from "components/TextInputAuth";
import ButtonJustifyEnd from "components/ButtonJustifyEnd";
import IconCheck from "icons/confirm-circle-white.svg";
import { EditNameGroup } from "services/manageFamilies";
import toastMessage from "helpers/handleToastMessage";
import { ToastContainer } from "react-toastify";

type Props = {};

const UpdateGroup: React.FC<Props> = (): JSX.Element => {
  let history = useHistory();
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const getDetails = async () => {
    try {
      setLoading(true);
      const { data } = await listGroupById(id);
      setName(data.name);
    } catch (error: any) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setId(history.location.pathname.split("/")[2]);
    if (id) {
      getDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history, id]);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      await EditNameGroup(id, name);

      toastMessage({
        message: "Edit name group successfully.",
        type: "success",
      });

      history.push(`/manage-families/${id}/details`);
    } catch (error: any) {
      toastMessage({
        message: "Error, Something went wrong.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dashboard
      title={name}
      icon={ArrowLeft}
      breadcrumb={[
        { name: "Manage Families", active: false, path: "/manage-families" },
        { name: `${name}`, active: false },
        { name: "Edit", active: true },
      ]}
      children={
        <>
          <Loading loading={loading} />
          <div className="bg-bt-white p-4">
            <div className="w-9/12 mx-auto mt-4">
              <TextInputAuth
                label={"Name"}
                placeholder={"Name"}
                value={name}
                onChange={(e: any) => setName(e.target.value)}
              />
            </div>
            <ButtonJustifyEnd
              title={"Confirm"}
              iconLeft={IconCheck}
              action={handleSubmit}
            />
            <ToastContainer />
          </div>
        </>
      }
    />
  );
};

export default UpdateGroup;
